// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WholesaleRouteImport } from './routes/wholesale'
import { Route as SnacksRouteImport } from './routes/snacks'
import { Route as PrivateLabelRouteImport } from './routes/private-label'
import { Route as InquiryRouteImport } from './routes/inquiry'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CertificationsRouteImport } from './routes/certifications'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as JournalIndexRouteImport } from './routes/journal.index'
import { Route as CollectionsIndexRouteImport } from './routes/collections.index'
import { Route as SnacksHandleRouteImport } from './routes/snacks_.$handle'
import { Route as ProductsHandleRouteImport } from './routes/products.$handle'
import { Route as JournalSlugRouteImport } from './routes/journal.$slug'
import { Route as CollectionsHandleRouteImport } from './routes/collections.$handle'

const WholesaleRoute = WholesaleRouteImport.update({
            id: '/wholesale',path: '/wholesale',getParentRoute: () => rootRouteImport
          })
const SnacksRoute = SnacksRouteImport.update({
            id: '/snacks',path: '/snacks',getParentRoute: () => rootRouteImport
          })
const PrivateLabelRoute = PrivateLabelRouteImport.update({
            id: '/private-label',path: '/private-label',getParentRoute: () => rootRouteImport
          })
const InquiryRoute = InquiryRouteImport.update({
            id: '/inquiry',path: '/inquiry',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CertificationsRoute = CertificationsRouteImport.update({
            id: '/certifications',path: '/certifications',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const JournalIndexRoute = JournalIndexRouteImport.update({
            id: '/journal/',path: '/journal/',getParentRoute: () => rootRouteImport
          })
const CollectionsIndexRoute = CollectionsIndexRouteImport.update({
            id: '/collections/',path: '/collections/',getParentRoute: () => rootRouteImport
          })
const SnacksHandleRoute = SnacksHandleRouteImport.update({
            id: '/snacks_/$handle',path: '/snacks/$handle',getParentRoute: () => rootRouteImport
          })
const ProductsHandleRoute = ProductsHandleRouteImport.update({
            id: '/products/$handle',path: '/products/$handle',getParentRoute: () => rootRouteImport
          })
const JournalSlugRoute = JournalSlugRouteImport.update({
            id: '/journal/$slug',path: '/journal/$slug',getParentRoute: () => rootRouteImport
          })
const CollectionsHandleRoute = CollectionsHandleRouteImport.update({
            id: '/collections/$handle',path: '/collections/$handle',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,CertificationsRoute: CertificationsRoute,ContactRoute: ContactRoute,InquiryRoute: InquiryRoute,PrivateLabelRoute: PrivateLabelRoute,SnacksRoute: SnacksRoute,WholesaleRoute: WholesaleRoute,CollectionsHandleRoute: CollectionsHandleRoute,JournalSlugRoute: JournalSlugRoute,ProductsHandleRoute: ProductsHandleRoute,SnacksHandleRoute: SnacksHandleRoute,CollectionsIndexRoute: CollectionsIndexRoute,JournalIndexRoute: JournalIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)